import { createFileRoute } from '@tanstack/react-router';

import { LinkSetupPage } from './-components/LinkSetupPage';

export const Route = createFileRoute('/_authenticated/externalContent/links/new')({
    component: LinkSetupPage,
});
